import { MerchandisingCommentService } from './merchandising-comment.service';

export default angular
  .module('sfMobile.services.merchandising-comment', [])
  .factory('merchandisingCommentFactory', MerchandisingCommentService).name;
